import axios from '@/utils/axios'
import { record } from '@/utils/helpers'

export function createIndividual (data) {
  return axios({
    url: '/individual_tour',
    method: 'post',
    data
  })
}

export function updateIndividual (id, form) {
  record([id], 'update', 'individual_tour')
  return axios({
    url: '/individual_tour/' + id,
    method: 'put',
    data: form
  })
}

export function deleteIndividual (individual) {
  record(individual, 'del', 'individual_tour')
  return axios({
    url: '/individual_tour',
    method: 'delete',
    data: { transaction_id_list: individual }
  })
}

export function getExchangeRate (data = { base: 'USD' }) {
  return axios({
    url: '/currency',
    method: 'post',
    data
  })
}

export function getIndividual (individual) {
  return axios({
    url: '/individual_tour/' + individual,
    method: 'get'
  })
}

export function createTransactionGroup (data) {
  return axios({
    url: '/transaction_group',
    method: 'post',
    data: {
      transaction_id_list: data.transaction_id_list,
      create_by: data.create_by
    }
  })
}

export function addTransactionToGroup (data) {
  return axios({
    url: '/transaction_group/update',
    method: 'post',
    data: {
      transaction_id_list: data.transaction_id_list,
      transaction_group_id: data.transaction_group_id
    }
  })
}

export function fetchGroupList (data) {
  return axios({
    url: '/transaction_group/list',
    method: 'post',
    data: {
      create_by: data.create_by
    }
  })
}

export function searchIndividualTour (form) {
  return axios({
    url: '/individual_tour_list',
    method: 'post',
    data: form
  })
}

export function createGroup (transactionIdList, userName) {
  return axios({
    url: '/transaction_group',
    method: 'post',
    data: {transaction_id_list: transactionIdList, create_by: userName}
  })
}

export function getGroupList (createBy) {
  return axios({
    url: '/transaction_group/list',
    method: 'post',
    data: {create_by: createBy}
  })
}

export function delGroup (groupId) {
  // record([groupId], 'del', username)
  return axios({
    url: '/transaction_group',
    method: 'delete',
    // headers: {'Access-Control-Allow-Origin': '*'},
    data: {transaction_group_id: groupId}
  })
}

export function getGroup (groupId) {
  return axios({
    url: '/transaction_group/' + groupId,
    method: 'get'
  })
}

export function searchGroup (billTo, issuedTime) {
  return axios({
    url: '/balance',
    method: 'post',
    // headers: {'Access-Control-Allow-Origin': '*'},
    data: {bill_to: billTo, issued_time: issuedTime}
  })
}
export function leaveGroup (list, id, createBy) {
  return axios({
    url: '/transaction_group/update',
    method: 'put',
    // headers: {'Access-Control-Allow-Origin': '*'},
    data: {
      'transaction_id_list': list,
      'transaction_group_id': id,
      'create_by': createBy
    }
  })
}

export function downloadExcel (data) {
  return axios({
    url: '/individual_tour_download/excel',
    method: 'post',
    // headers: {'Access-Control-Allow-Origin': '*'},
    responseType: 'blob',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/individualTour.js